<a class="btn btn--primary" [href]="url" target="_blank">
    <ng-content></ng-content>
</a>
